import { render, staticRenderFns } from "./ach.vue?vue&type=template&id=c3f6c764"
import script from "./ach.vue?vue&type=script&lang=js"
export * from "./ach.vue?vue&type=script&lang=js"
import style0 from "./ach.vue?vue&type=style&index=0&id=c3f6c764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports